import { render, staticRenderFns } from "./ConsumerCustomerActivityReport.vue?vue&type=template&id=93996b66&"
import script from "./ConsumerCustomerActivityReport.vue?vue&type=script&lang=js&"
export * from "./ConsumerCustomerActivityReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports